var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.LeadData && _vm.Timetable
    ? _c(
        "div",
        { staticClass: "lead-timeline" },
        [
          _c("span", { staticClass: "timeline-menu-list-ttl" }, [
            _vm._v("Timeline"),
          ]),
          _vm._v(" "),
          _c("menu-time-line"),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "lead-timeline-content" },
            _vm._l(_vm.Timetable, function (items) {
              return _c(
                "div",
                {
                  staticClass: "lead-timeline__item",
                  class: { "lead-timeline__item--group": items.length > 1 },
                },
                [
                  items[0].action_type === "comments"
                    ? _c("comment-type", { attrs: { items: items } })
                    : _vm._e(),
                  _vm._v(" "),
                  items[0].action_type === "updates"
                    ? _c("updates-type", { attrs: { items: items } })
                    : _vm._e(),
                ],
                1
              )
            }),
            0
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }